import styled from 'styled-components'
import { Button, Layout, Col, Checkbox } from 'antd'

const StyledHeader = styled(Layout.Header)`
  padding: 0.75rem;
  display: flex;
  gap: 1rem;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  z-index: 10;
  background: ${props => props.theme.lightGray};
  @media (max-width: ${props => props.theme.size.sm}) {
    .header-user-info {
      display: none;
    }
  }
`

const LogoContainerMobile = styled.div`
  display: flex;
  align-items: center;
  margin: 12px;
`

const LogoContainer = styled.div`
  display: flex;
  width: 10rem;
  min-width: 8.5rem;
  .displayer {
    cursor: pointer;
    display: flex;
    font-size: 1.25rem;
    padding: 0.5rem 1rem 0.5rem 0.5rem;
  }
  @media (max-width: ${props => props.theme.size.md}) {
    width: 6rem;
  }
`
const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  & > * {
    font-size: 14px;
  }
  .search-type {
    max-width: 7.5rem;
  }
  .ticket-search-input {
    max-width: 12rem;
    min-width: 7.3rem;
  }
  @media (max-width: ${props => props.theme.size.xs}) {
    .ticket-search-input,
    .search-type {
      font-size: 12px;
    }
    .ticket-search-input {
      min-width: 6.5rem;
    }
  }
`

const MenuOverlay = styled.div`
  display: none;
  @media (max-width: ${props => props.theme.size.md}) {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.45);
    z-index: 7;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease;
    &.visible {
      opacity: 1;
      pointer-events: all;
    }
  }
`

const StyledSider = styled(Layout.Sider)`
  background: white;
  z-index: 8;
  box-shadow: 0 0 0 ${props => props.theme.darkGray};
  .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
  }
  .menu-content {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 0;
    background: white;
    -webkit-overflow-scrolling: touch;
    .ant-menu {
      background: white !important;
    }
    @media (max-width: ${props => props.theme.size.md}) {
      touch-action: pan-y;
    }
  }
  .menu-user-info {
    display: none;
    justify-content: center;
    padding: 1rem;
    flex-shrink: 0;
    color: white;
    position: relative;
    z-index: 1;
    * {
      color: white !important;
    }
    .ant-tooltip {
      * {
        color: initial !important;
      }
    }
  }

  @media (max-width: ${props => props.theme.size.sm}) {
    .menu-user-info {
      display: flex;
    }
  }
  @media (max-width: ${props => props.theme.size.md}) {
    transform: translateX(-100%);
    position: fixed !important;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 9;
    &.menu-displayed {
      transform: unset;
      box-shadow: 0 0 1rem ${props => props.theme.darkGray};
    }
    .ant-layout-sider-children {
      height: 100%;
    }
    .menu-content {
      flex: 1;
      min-height: 0;
    }
  }
`
const ContainerButtons = styled.div`
  & > button {
    margin-top: 15px;
  }
  & button:last-child {
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    color: black;
    & > span {
      margin-left: 8px;
    }
  }
  & button:nth-child(2) {
    background-color: transparent;
    color: ${({ theme }) => theme.gray};
  }
  margin-bottom: 20%;
`

const ContainerCheckbox = styled(Col)`
  & > label {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    padding: 4px 0 4px;
    & span:last-child {
      padding-left: 0;
      flex: 1;
    }
  }
`
const StyledCheckboxGroup = styled(Checkbox.Group)`
  width: 100%;
  & > p {
    margin-bottom: 5px;
    margin-top: 15px;
    font-weight: bold;
  }
`

interface ButtonProps {
  svgColor: string
}
const StyledButton = styled(Button)<ButtonProps>`
  & > span > svg {
    color: ${({ svgColor }) => svgColor};
  }
`

const StyledContainer = styled(Layout.Content)`
  background-color: white;
  position: relative;
`
const ContainerTable = styled.div`
  padding: 4%;
`
interface UserColorProps {
  role: string | undefined
}

const RoleUserColor: { [key: string]: string } = {
  ADMIN: '#7A7A7A',
  CARRIER: '#E04040',
  SUPPLIER: '#6DC363',
  COMMERCIAL: '#6DC363',
  PROCUREMENT: '#0C479D',
  ADMINRO: '#ffaf05',
}

const UserColor = styled.div<UserColorProps>`
  width: 100%;
  height: 3px;
  background-color: ${props => (props.role ? RoleUserColor[props.role] : 'transparent')};
`

const LogoutContainer = styled.div`
  width: 1.5rem;
  height: 2rem;
  display: flex;
  align-items: center;
  & > svg {
    width: 100%;
    height: 100%;
  }
  & > svg:hover {
    -webkit-filter: drop-shadow(3px 2px 1px rgba(0, 0, 0, 0.5));
    filter: drop-shadow(3px 2px 1px rgba(0, 0, 0, 0.5));
  }
  &:hover {
    cursor: pointer;
  }
`

const LoginInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #939393;
  font-family: Roboto, Arial, Helvetica;
  font-style: normal;
  line-height: 16px;
  gap: 0.4rem;
  & > h4 {
    color: inherit;
    font-size: 17px;
    font-weight: 600;
    margin: unset;
  }

  & > p {
    color: inherit;
    font-size: 14px;
    font-weight: 400;
    margin: unset;
  }
`

const UserContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
`
const UserContainerMobile = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
`

const JobUpdateContainer = styled.div`
  line-height: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  color: #939393;
  .load-icon {
    font-size: 1.5rem;
    align-items: center;
    display: flex;
  }
  p {
    margin-bottom: 0;
  }
`

export {
  JobUpdateContainer,
  StyledHeader,
  LogoContainer,
  SearchContainer,
  StyledSider,
  MenuOverlay,
  StyledButton,
  ContainerButtons,
  ContainerCheckbox,
  StyledCheckboxGroup,
  ContainerTable,
  StyledContainer,
  UserColor,
  LogoutContainer,
  LoginInfoContainer,
  UserContainer,
  LogoContainerMobile,
  UserContainerMobile,
}
